import { useState } from "react";

export function useReadingWindowState(initialState) {
  const [chapterPopoverOffsetY, setChapterPopoverOffsetY] = useState(0);
  const [isChapterPopoverDragging, setIsChapterPopoverDragging] = useState(false);
  const [readingWindowUserOffsetY, setReadingWindowUserOffsetY] = useState(0);
  const [readingWindowAutoOffsetY, setReadingWindowAutoOffsetY] = useState(0);
  const [isReadingWindowDragging, setIsReadingWindowDragging] = useState(false);
  const [isPureReadingMode, setIsPureReadingMode] = useState(false);
  const [pureReadingIndex, setPureReadingIndex] = useState(initialState.currentIndex);
  const [pureReadingDisplaySnapshot, setPureReadingDisplaySnapshot] = useState(() => ({
    chapterIndex: initialState.currentChapterIndex,
    blockIndex: initialState.currentIndex,
    showTranslated: false
  }));
  const [readingWindowPlaybackCursor, setReadingWindowPlaybackCursor] = useState(() => ({
    chapterIndex: initialState.currentChapterIndex,
    blockIndex: initialState.currentIndex,
    offsetChars: Number(initialState.playbackSnapshot?.offsetChars || 0)
  }));

  return {
    chapterPopoverOffsetY,
    setChapterPopoverOffsetY,
    isChapterPopoverDragging,
    setIsChapterPopoverDragging,
    readingWindowUserOffsetY,
    setReadingWindowUserOffsetY,
    readingWindowAutoOffsetY,
    setReadingWindowAutoOffsetY,
    isReadingWindowDragging,
    setIsReadingWindowDragging,
    isPureReadingMode,
    setIsPureReadingMode,
    pureReadingIndex,
    setPureReadingIndex,
    pureReadingDisplaySnapshot,
    setPureReadingDisplaySnapshot,
    readingWindowPlaybackCursor,
    setReadingWindowPlaybackCursor
  };
}
